export default "__VITE_ASSET__478ba5ba__$_?component__"